// import firebase from "firebase/app";
// import * as firebase from "firebase/app";
// import "firebase/firestore";
// import "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const DB_TYPE="Production";
const firebaseConfig = {
  apiKey: "AIzaSyCc-uyC2ET3g0PmRWLRv9ep_IAdTFXhgZU",
  authDomain: "mathapp-5668f.firebaseapp.com",
  projectId: "mathapp-5668f",
  storageBucket: "mathapp-5668f.firebasestorage.app",
  messagingSenderId: "849798603758",
  appId: "1:849798603758:web:bb66172c795524f717e4ff",
  measurementId: "G-R0KHNG5GH2"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
console.log(db)
const auth =  firebase.auth();

export { auth, db, DB_TYPE, analytics };